import { CheckCircle2, Circle } from "lucide-react";

import {
  TrainingStatus,
  type ExerciseInWorkout,
  type ProgramWorkout,
} from "@fitness-app/data-models/entities/TrainingProgram";
import { cn } from "@fitness-app/utils/src/styles/cn";

import ExerciseInfo from "~/components/ExerciseInfo/ExerciseInfo";
import { PopoverSection } from "~/components/EventCalendar/EventPopover";

interface WorkoutExerciseListProps {
  workout: ProgramWorkout;
  // Trening z planu, który jeszcze nie ruszył: nie ma czego odhaczać.
  showProgress?: boolean;
}

const ExerciseRow = ({ exercise, showProgress }: { exercise: ExerciseInWorkout; showProgress: boolean }) => {
  const done = exercise.status === TrainingStatus.FULFILLED;

  return (
    <li className="flex items-start gap-2.5">
      {showProgress &&
        (done ? (
          <CheckCircle2 size={16} className="mt-px shrink-0 text-green-600" />
        ) : (
          <Circle size={16} className="mt-px shrink-0 text-gray-300" />
        ))}
      <div className="min-w-0 flex-1">
        <div
          className={cn("text-[13px] font-medium leading-5 text-gray-900", showProgress && !done && "text-gray-600")}
        >
          {exercise.exercise.name}
        </div>
        <div className="flex flex-wrap gap-x-1 text-xs tabular-nums text-gray-500">
          <ExerciseInfo exerciseInWorkout={exercise} separator="·" />
        </div>
      </div>
    </li>
  );
};

export const WorkoutExerciseList = ({ workout, showProgress = true }: WorkoutExerciseListProps) => {
  const sections = [
    { label: "Rozgrzewka", exercises: workout.preWorkout },
    { label: "Trening", exercises: workout.exercises },
    { label: "Po treningu", exercises: workout.postWorkout },
  ].filter((section) => section.exercises.length);

  if (!sections.length) {
    return <p className="m-0 py-2 text-center text-[13px] text-gray-400">Lista ćwiczeń jest pusta</p>;
  }

  return (
    <>
      {sections.map((section) => (
        <PopoverSection key={section.label} label={sections.length > 1 ? section.label : undefined}>
          <ul className="m-0 flex list-none flex-col gap-2.5 p-0">
            {section.exercises.map((exercise) => (
              <ExerciseRow key={exercise.id} exercise={exercise} showProgress={showProgress} />
            ))}
          </ul>
        </PopoverSection>
      ))}
    </>
  );
};
